import { AppConfiguratorComponent } from '@/layout/components/app.configurator.component';
import { LayoutService } from '@/layout/service/layout.service';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [RouterModule, AppConfiguratorComponent],
  template: ` <section
      class="animate-fadein animate-duration-300 animate-ease-in relative min-h-screen flex items-center justify-center"
    >
      <div class="landing-container mx-auto relative z-10 px-12">
        <div class="relative mt-24 max-w-[46rem] mx-auto">
          <div
            class="w-full h-full inset-0 bg-white/64 dark:bg-surface-800 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rotate-[4deg] lg:rotate-[7deg] backdrop-blur-[90px] rounded-3xl shadow-[0px_87px_24px_0px_rgba(120,149,206,0.00),0px_56px_22px_0px_rgba(120,149,206,0.01),0px_31px_19px_0px_rgba(120,149,206,0.03),0px_14px_14px_0px_rgba(120,149,206,0.04),0px_3px_8px_0px_rgba(120,149,206,0.06)] dark:shadow-sm"
          ></div>
          <div
            class="w-full h-full inset-0 bg-white/64 dark:bg-surface-800 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-[4deg] lg:-rotate-[7deg] backdrop-blur-[90px] rounded-3xl shadow-[0px_87px_24px_0px_rgba(120,149,206,0.00),0px_56px_22px_0px_rgba(120,149,206,0.01),0px_31px_19px_0px_rgba(120,149,206,0.03),0px_14px_14px_0px_rgba(120,149,206,0.04),0px_3px_8px_0px_rgba(120,149,206,0.06)] dark:shadow-sm"
          ></div>
          <div
            class="flex flex-col items-center p-8 py-20 relative z-10 bg-white/64 dark:bg-surface-800 backdrop-blur-[90px] rounded-3xl shadow-[0px_87px_24px_0px_rgba(120,149,206,0.00),0px_56px_22px_0px_rgba(120,149,206,0.01),0px_31px_19px_0px_rgba(120,149,206,0.03),0px_14px_14px_0px_rgba(120,149,206,0.04),0px_3px_8px_0px_rgba(120,149,206,0.06)]"
          >
            <svg
              class="lg:w-[687px] w-[300px] h-auto"
              width="687"
              height="319"
              viewBox="0 0 687 319"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M205.857 86.6021H89.1368C85.5366 86.6021 82.6182 89.5225 82.6182 93.1251V220.954C82.6182 224.557 85.5366 227.477 89.1368 227.477H205.857C209.457 227.477 212.375 224.557 212.375 220.954V93.1251C212.375 89.5225 209.457 86.6021 205.857 86.6021Z"
                fill="#3B82F6"
              />
              <path
                d="M193.977 105.685H101.001C98.3404 105.685 96.1836 107.843 96.1836 110.506V203.545C96.1836 206.207 98.3404 208.366 101.001 208.366H193.977C196.637 208.366 198.794 206.207 198.794 203.545V110.506C198.794 107.843 196.637 105.685 193.977 105.685Z"
                fill="#172554"
              />
              <path
                d="M218.665 227.477H76.3134C71.0079 227.477 66.707 231.781 66.707 237.09V272.609C66.707 277.918 71.0079 282.222 76.3134 282.222H218.665C223.97 282.222 228.271 277.918 228.271 272.609V237.09C228.271 231.781 223.97 227.477 218.665 227.477Z"
                fill="#2563EB"
              />
              <path
                d="M228.271 237.09H66.707V248.162H228.271V237.09Z"
                fill="#93C5FD"
              />
              <path
                d="M217.599 251.867H170.958C169.318 251.867 167.989 253.196 167.989 254.835C167.989 256.475 169.318 257.804 170.958 257.804H217.599C219.238 257.804 220.567 256.475 220.567 254.835C220.567 253.196 219.238 251.867 217.599 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M161.418 251.867H154.846C153.207 251.867 151.878 253.196 151.878 254.835C151.878 256.475 153.207 257.803 154.846 257.803H161.418C163.057 257.803 164.386 256.475 164.386 254.835C164.386 253.196 163.057 251.867 161.418 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M144.52 251.867H137.949C136.309 251.867 134.98 253.196 134.98 254.835C134.98 256.475 136.309 257.804 137.949 257.804H144.52C146.16 257.804 147.489 256.475 147.489 254.835C147.489 253.196 146.16 251.867 144.52 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M128.548 257.818C130.19 257.818 131.521 256.486 131.521 254.842C131.521 253.199 130.19 251.867 128.548 251.867C126.905 251.867 125.574 253.199 125.574 254.842C125.574 256.486 126.905 257.818 128.548 257.818Z"
                fill="#EFF6FF"
              />
              <path
                d="M195.836 220.682C197.478 220.682 198.809 219.35 198.809 217.707C198.809 216.063 197.478 214.731 195.836 214.731C194.194 214.731 192.862 216.063 192.862 217.707C192.862 219.35 194.194 220.682 195.836 220.682Z"
                fill="#EFF6FF"
              />
              <path
                d="M99.3628 239.722H74.7218C73.1851 239.722 71.9395 240.968 71.9395 242.504C71.9395 244.041 73.1851 245.287 74.7218 245.287H99.3628C100.899 245.287 102.145 244.041 102.145 242.504C102.145 240.968 100.899 239.722 99.3628 239.722Z"
                fill="#EFF6FF"
              />
              <g opacity="0.2">
                <path
                  d="M175.236 124.868H159.84L139.884 144.866H131.965C130.821 144.866 129.892 145.796 129.892 146.94C129.892 148.085 130.821 149.014 131.965 149.014H136.239C136.882 149.014 137.411 149.544 137.411 150.187C137.411 150.831 136.882 151.36 136.239 151.36H133.423L119.228 165.594L116.269 174.863H143.172L139.012 187.938H153.222C154.365 187.938 155.294 187.008 155.294 185.864C155.294 184.72 154.437 183.876 153.35 183.804H153.222H152.778C152.135 183.804 151.606 183.275 151.606 182.631C151.606 181.987 152.135 181.458 152.778 181.458H154.094L156.195 174.878H163.786L167.088 164.521H159.497L168.46 136.383H171.991C173.135 136.383 174.064 135.453 174.064 134.309C174.064 133.165 173.135 132.235 171.991 132.235H169.132C168.489 132.235 167.96 131.705 167.96 131.062C167.96 130.418 168.489 129.889 169.132 129.889H175.236C176.623 129.889 177.738 128.773 177.738 127.385C177.738 125.998 176.623 124.882 175.236 124.882V124.868ZM152.564 146.039C151.335 149.429 150.448 152.018 149.876 153.807L146.474 164.507H131.307L148.433 147.04C150.634 144.794 152.65 142.491 154.465 140.145H154.808C154.551 140.689 153.808 142.663 152.578 146.053L152.564 146.039Z"
                  fill="white"
                />
                <path
                  d="M183.241 124.868H182.269C180.883 124.868 179.768 125.983 179.768 127.371C179.768 128.759 180.883 129.874 182.269 129.874H183.241C184.628 129.874 185.743 128.759 185.743 127.371C185.743 125.983 184.628 124.868 183.241 124.868Z"
                  fill="white"
                />
              </g>
              <path
                opacity="0.1"
                d="M137.999 115.827C137.999 113.014 135.719 110.734 132.906 110.734H109.909H107.745C103.327 110.734 99.7451 114.316 99.7451 118.734V120.919V143.932C99.7451 146.739 102.02 149.014 104.827 149.014C107.634 149.014 109.909 146.739 109.909 143.932V121.919C109.909 121.367 110.357 120.919 110.909 120.919H132.906C135.719 120.919 137.999 118.639 137.999 115.827Z"
                fill="white"
              />
              <path
                opacity="0.1"
                d="M194.092 197.698V169.596C194.092 166.785 191.814 164.507 189.003 164.507C186.193 164.507 183.914 166.785 183.914 169.596V197.698C183.914 200.508 186.193 202.787 189.003 202.787C191.814 202.787 194.092 200.508 194.092 197.698Z"
                fill="white"
              />
              <mask
                id="mask0_2516_33271"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="96"
                y="105"
                width="103"
                height="104"
              >
                <path
                  d="M193.977 105.685H101.001C98.3404 105.685 96.1836 107.843 96.1836 110.506V203.545C96.1836 206.207 98.3404 208.366 101.001 208.366H193.977C196.637 208.366 198.794 206.207 198.794 203.545V110.506C198.794 107.843 196.637 105.685 193.977 105.685Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2516_33271)">
                <g opacity="0.5">
                  <path
                    opacity="0.1"
                    d="M198.794 107.645H96.1836V109.562H198.794V107.645Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 111.478H96.1836V113.395H198.794V111.478Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 115.312H96.1836V117.229H198.794V115.312Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 119.131H96.1836V121.048H198.794V119.131Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 122.965H96.1836V124.882H198.794V122.965Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 126.785H96.1836V128.702H198.794V126.785Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 130.618H96.1836V132.535H198.794V130.618Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 134.452H96.1836V136.369H198.794V134.452Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 138.271H96.1836V140.188H198.794V138.271Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 142.105H96.1836V144.022H198.794V142.105Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 145.925H96.1836V147.842H198.794V145.925Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 149.758H96.1836V151.675H198.794V149.758Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 153.592H96.1836V155.509H198.794V153.592Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 157.411H96.1836V159.328H198.794V157.411Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 161.245H96.1836V163.162H198.794V161.245Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 165.065H96.1836V166.982H198.794V165.065Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 168.898H96.1836V170.815H198.794V168.898Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 172.718H96.1836V174.635H198.794V172.718Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 176.552H96.1836V178.468H198.794V176.552Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 180.385H96.1836V182.302H198.794V180.385Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 184.205H96.1836V186.122H198.794V184.205Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 188.038H96.1836V189.955H198.794V188.038Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 191.858H96.1836V193.775H198.794V191.858Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 195.692H96.1836V197.608H198.794V195.692Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 199.525H96.1836V201.442H198.794V199.525Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 203.345H96.1836V205.261H198.794V203.345Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M198.794 207.178H96.1836V209.095H198.794V207.178Z"
                    fill="white"
                  />
                </g>
                <path
                  opacity="0.1"
                  d="M122.401 187.423C122.058 187.023 121.458 186.966 121.057 187.309L116.54 191.128L113.552 185.664C113.452 185.464 113.281 185.32 113.066 185.235L106.919 182.76C106.433 182.56 105.876 182.803 105.676 183.289C105.476 183.776 105.719 184.333 106.205 184.534L112.037 186.88L115.053 192.373L111.994 194.962C111.723 195.191 111.608 195.549 111.68 195.892C111.751 196.235 112.009 196.507 112.337 196.607L117.469 198.138L108.663 210.039C108.349 210.469 108.435 211.055 108.864 211.37C109.035 211.499 109.235 211.556 109.435 211.556C109.721 211.556 110.021 211.427 110.207 211.169L119.828 198.166C120.014 197.909 120.071 197.594 119.971 197.294C119.871 196.993 119.642 196.764 119.342 196.679L114.596 195.262L122.315 188.754C122.716 188.41 122.773 187.81 122.43 187.409L122.401 187.423Z"
                  fill="white"
                />
              </g>
              <path
                d="M34 45.318L53.9703 52.6135L66.0497 57.0337L61.3466 69.9225L78.9297 83.7697L58.9593 76.4598L46.8799 72.0396L51.583 59.1509L34 45.318Z"
                fill="#EAB308"
              />
              <path
                d="M84.9622 33.9313L89.5081 48.8084L92.2527 57.8062L82.6607 60.7387L82.3462 77.1036L77.8003 62.2264L75.0557 53.2286L84.6477 50.2961L84.9622 33.9313Z"
                fill="#EAB308"
              />
              <path
                d="M597.664 86.6021H480.944C477.344 86.6021 474.426 89.5225 474.426 93.1251V220.954C474.426 224.557 477.344 227.477 480.944 227.477H597.664C601.264 227.477 604.183 224.557 604.183 220.954V93.1251C604.183 89.5225 601.264 86.6021 597.664 86.6021Z"
                fill="#3B82F6"
              />
              <path
                d="M610.48 227.477H468.129C462.823 227.477 458.522 231.781 458.522 237.09V272.609C458.522 277.918 462.823 282.222 468.129 282.222H610.48C615.785 282.222 620.086 277.918 620.086 272.609V237.09C620.086 231.781 615.785 227.477 610.48 227.477Z"
                fill="#2563EB"
              />
              <path
                d="M585.792 105.685H492.816C490.156 105.685 487.999 107.843 487.999 110.506V203.545C487.999 206.207 490.156 208.366 492.816 208.366H585.792C588.453 208.366 590.61 206.207 590.61 203.545V110.506C590.61 107.843 588.453 105.685 585.792 105.685Z"
                fill="#172554"
              />
              <path
                d="M620.086 237.09H458.522V248.162H620.086V237.09Z"
                fill="#93C5FD"
              />
              <path
                d="M609.398 251.867H562.757C561.118 251.867 559.789 253.196 559.789 254.835C559.789 256.475 561.118 257.803 562.757 257.803H609.398C611.038 257.803 612.367 256.475 612.367 254.835C612.367 253.196 611.038 251.867 609.398 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M553.219 251.867H546.647C545.008 251.867 543.679 253.196 543.679 254.835C543.679 256.475 545.008 257.803 546.647 257.803H553.219C554.858 257.803 556.187 256.475 556.187 254.835C556.187 253.196 554.858 251.867 553.219 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M536.336 251.867H529.764C528.125 251.867 526.796 253.196 526.796 254.835C526.796 256.475 528.125 257.803 529.764 257.803H536.336C537.975 257.803 539.304 256.475 539.304 254.835C539.304 253.196 537.975 251.867 536.336 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M520.363 257.818C522.005 257.818 523.336 256.486 523.336 254.842C523.336 253.199 522.005 251.867 520.363 251.867C518.721 251.867 517.39 253.199 517.39 254.842C517.39 256.486 518.721 257.818 520.363 257.818Z"
                fill="#EFF6FF"
              />
              <path
                d="M587.637 220.682C589.279 220.682 590.61 219.35 590.61 217.707C590.61 216.064 589.279 214.731 587.637 214.731C585.994 214.731 584.663 216.064 584.663 217.707C584.663 219.35 585.994 220.682 587.637 220.682Z"
                fill="#EFF6FF"
              />
              <path
                d="M491.178 239.722H466.537C465.001 239.722 463.755 240.968 463.755 242.504C463.755 244.041 465.001 245.287 466.537 245.287H491.178C492.715 245.287 493.961 244.041 493.961 242.504C493.961 240.968 492.715 239.722 491.178 239.722Z"
                fill="#EFF6FF"
              />
              <mask
                id="mask1_2516_33271"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="487"
                y="105"
                width="104"
                height="104"
              >
                <path
                  d="M585.792 105.685H492.816C490.156 105.685 487.999 107.843 487.999 110.506V203.545C487.999 206.207 490.156 208.366 492.816 208.366H585.792C588.453 208.366 590.61 206.207 590.61 203.545V110.506C590.61 107.843 588.453 105.685 585.792 105.685Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_2516_33271)">
                <g opacity="0.5">
                  <path
                    opacity="0.1"
                    d="M590.61 107.645H487.999V109.562H590.61V107.645Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 111.478H487.999V113.395H590.61V111.478Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 115.312H487.999V117.229H590.61V115.312Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 119.131H487.999V121.048H590.61V119.131Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 122.965H487.999V124.882H590.61V122.965Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 126.785H487.999V128.702H590.61V126.785Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 130.618H487.999V132.535H590.61V130.618Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 134.452H487.999V136.369H590.61V134.452Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 138.271H487.999V140.188H590.61V138.271Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 142.105H487.999V144.022H590.61V142.105Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 145.925H487.999V147.842H590.61V145.925Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 149.758H487.999V151.675H590.61V149.758Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 153.592H487.999V155.509H590.61V153.592Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 157.411H487.999V159.328H590.61V157.411Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 161.245H487.999V163.162H590.61V161.245Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 165.065H487.999V166.982H590.61V165.065Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 168.898H487.999V170.815H590.61V168.898Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 172.718H487.999V174.635H590.61V172.718Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 176.552H487.999V178.468H590.61V176.552Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 180.385H487.999V182.302H590.61V180.385Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 184.205H487.999V186.122H590.61V184.205Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 188.038H487.999V189.955H590.61V188.038Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 191.858H487.999V193.775H590.61V191.858Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 195.692H487.999V197.608H590.61V195.692Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 199.525H487.999V201.442H590.61V199.525Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 203.345H487.999V205.261H590.61V203.345Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M590.61 207.178H487.999V209.095H590.61V207.178Z"
                    fill="white"
                  />
                </g>
              </g>
              <path
                opacity="0.1"
                d="M529.999 115.827C529.999 113.014 527.719 110.734 524.906 110.734H501.909H499.745C495.327 110.734 491.745 114.316 491.745 118.734V120.919V143.932C491.745 146.739 494.02 149.014 496.827 149.014C499.634 149.014 501.909 146.739 501.909 143.932V121.919C501.909 121.367 502.357 120.919 502.909 120.919H524.906C527.719 120.919 529.999 118.639 529.999 115.827Z"
                fill="white"
              />
              <path
                opacity="0.1"
                d="M586.092 197.698V169.596C586.092 166.785 583.814 164.507 581.003 164.507C578.193 164.507 575.914 166.785 575.914 169.596V197.698C575.914 200.508 578.193 202.787 581.003 202.787C583.814 202.787 586.092 200.508 586.092 197.698Z"
                fill="white"
              />
              <path
                d="M649.648 128.015L636.825 128.558L629.063 128.887L628.72 120.605L615.726 116.943L628.534 116.413L636.296 116.084L636.639 124.367L649.648 128.015Z"
                fill="#EAB308"
              />
              <path
                d="M623.846 146.139L617.885 138.887L614.269 134.509L618.943 130.647L615.341 121.449L621.316 128.701L624.918 133.079L620.244 136.941L623.846 146.139Z"
                fill="#EAB308"
              />
              <g opacity="0.3">
                <path
                  d="M559.532 175.722H552.213C552.127 180.943 552.799 183.561 557.845 188.796H545.608C540.448 183.575 539.69 180.957 539.661 175.722H513.701C513.487 172.017 513.93 170.157 515.131 166.452C526.553 156.038 547.452 143.507 546.766 125.74C551.97 125.74 554.586 125.74 559.789 125.74C571.54 138.157 561.19 153.478 554.8 165.379H562.276C560.432 169.513 559.675 171.588 559.546 175.736L559.532 175.722ZM541.992 165.365C543.721 161.088 544.993 158.942 547.095 154.665C547.967 152.877 549.368 150.288 550.683 146.897C551.998 143.507 552.27 141.533 552.413 140.989H552.055C550.712 143.35 548.753 145.653 546.409 147.884C539.161 154.865 534.215 158.37 527.039 165.351H541.977L541.992 165.365Z"
                  fill="white"
                />
              </g>
              <path
                d="M552.528 76.3167L542.45 71.31C541.106 70.6377 540.563 69.0069 541.22 67.6766C541.892 66.3319 543.508 65.7883 544.851 66.4463L554.929 71.4531C556.273 72.1254 556.816 73.7562 556.159 75.0865C555.487 76.4312 553.857 76.9748 552.528 76.3167Z"
                fill="#EAB308"
              />
              <path
                d="M560.032 67.9913L555.901 57.5201C555.358 56.1182 556.03 54.5447 557.43 54.0011C558.831 53.4575 560.404 54.1298 560.947 55.5317L565.078 66.0029C565.622 67.4048 564.95 68.9783 563.549 69.5219C562.148 70.0655 560.575 69.3932 560.032 67.9913Z"
                fill="#EAB308"
              />
              <path
                d="M401.757 86.6022H285.037C281.437 86.6022 278.519 89.5226 278.519 93.1252V220.954C278.519 224.557 281.437 227.477 285.037 227.477H401.757C405.357 227.477 408.276 224.557 408.276 220.954V93.1252C408.276 89.5226 405.357 86.6022 401.757 86.6022Z"
                fill="#3B82F6"
              />
              <path
                d="M389.878 105.685H296.902C294.242 105.685 292.085 107.843 292.085 110.506V203.545C292.085 206.208 294.242 208.366 296.902 208.366H389.878C392.539 208.366 394.696 206.208 394.696 203.545V110.506C394.696 107.843 392.539 105.685 389.878 105.685Z"
                fill="#172554"
              />
              <path
                d="M414.58 227.477H272.228C266.923 227.477 262.622 231.781 262.622 237.09V272.609C262.622 277.918 266.923 282.222 272.228 282.222H414.58C419.885 282.222 424.186 277.918 424.186 272.609V237.09C424.186 231.781 419.885 227.477 414.58 227.477Z"
                fill="#2563EB"
              />
              <path
                d="M424.186 237.09H262.622V248.162H424.186V237.09Z"
                fill="#93C5FD"
              />
              <path
                d="M413.498 251.867H366.857C365.218 251.867 363.889 253.196 363.889 254.835C363.889 256.475 365.218 257.804 366.857 257.804H413.498C415.137 257.804 416.466 256.475 416.466 254.835C416.466 253.196 415.137 251.867 413.498 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M357.318 251.867H350.747C349.107 251.867 347.778 253.196 347.778 254.835C347.778 256.475 349.107 257.804 350.747 257.804H357.318C358.958 257.804 360.287 256.475 360.287 254.835C360.287 253.196 358.958 251.867 357.318 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M340.422 251.867H333.85C332.211 251.867 330.882 253.196 330.882 254.835C330.882 256.475 332.211 257.804 333.85 257.804H340.422C342.061 257.804 343.39 256.475 343.39 254.835C343.39 253.196 342.061 251.867 340.422 251.867Z"
                fill="#EFF6FF"
              />
              <path
                d="M324.463 257.818C326.105 257.818 327.436 256.486 327.436 254.842C327.436 253.199 326.105 251.867 324.463 251.867C322.82 251.867 321.489 253.199 321.489 254.842C321.489 256.486 322.82 257.818 324.463 257.818Z"
                fill="#EFF6FF"
              />
              <path
                d="M391.736 220.682C393.378 220.682 394.709 219.35 394.709 217.707C394.709 216.064 393.378 214.731 391.736 214.731C390.094 214.731 388.763 216.064 388.763 217.707C388.763 219.35 390.094 220.682 391.736 220.682Z"
                fill="#EFF6FF"
              />
              <path
                d="M295.278 239.722H270.637C269.1 239.722 267.854 240.968 267.854 242.504C267.854 244.041 269.1 245.287 270.637 245.287H295.278C296.814 245.287 298.06 244.041 298.06 242.504C298.06 240.968 296.814 239.722 295.278 239.722Z"
                fill="#EFF6FF"
              />
              <mask
                id="mask2_2516_33271"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="292"
                y="105"
                width="103"
                height="104"
              >
                <path
                  d="M389.878 105.685H296.902C294.242 105.685 292.085 107.843 292.085 110.506V203.545C292.085 206.208 294.242 208.366 296.902 208.366H389.878C392.539 208.366 394.696 206.208 394.696 203.545V110.506C394.696 107.843 392.539 105.685 389.878 105.685Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask2_2516_33271)">
                <g opacity="0.5">
                  <path
                    opacity="0.1"
                    d="M394.696 107.645H292.085V109.562H394.696V107.645Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 111.479H292.085V113.395H394.696V111.479Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 115.312H292.085V117.229H394.696V115.312Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 119.132H292.085V121.048H394.696V119.132Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 122.965H292.085V124.882H394.696V122.965Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 126.785H292.085V128.702H394.696V126.785Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 130.619H292.085V132.535H394.696V130.619Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 134.452H292.085V136.369H394.696V134.452Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 138.272H292.085V140.188H394.696V138.272Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 142.105H292.085V144.022H394.696V142.105Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 145.925H292.085V147.842H394.696V145.925Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 149.759H292.085V151.675H394.696V149.759Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 153.592H292.085V155.509H394.696V153.592Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 157.412H292.085V159.328H394.696V157.412Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 161.245H292.085V163.162H394.696V161.245Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 165.065H292.085V166.982H394.696V165.065Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 168.898H292.085V170.815H394.696V168.898Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 172.718H292.085V174.635H394.696V172.718Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 176.552H292.085V178.469H394.696V176.552Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 180.385H292.085V182.302H394.696V180.385Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 184.205H292.085V186.122H394.696V184.205Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 188.038H292.085V189.955H394.696V188.038Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 191.858H292.085V193.775H394.696V191.858Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 195.692H292.085V197.609H394.696V195.692Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 199.525H292.085V201.442H394.696V199.525Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 203.345H292.085V205.262H394.696V203.345Z"
                    fill="white"
                  />
                  <path
                    opacity="0.1"
                    d="M394.696 207.178H292.085V209.095H394.696V207.178Z"
                    fill="white"
                  />
                </g>
                <path
                  opacity="0.8"
                  d="M362.087 159.472C358.371 153.95 352.867 151.189 345.605 151.189C338.343 151.189 332.596 153.821 329.008 159.1C325.42 164.378 323.619 172.575 323.619 183.704C323.619 194.833 325.463 202.444 329.151 207.908C332.84 213.373 338.329 216.105 345.591 216.105C352.853 216.105 358.642 213.458 362.245 208.166C365.847 202.873 367.648 194.719 367.648 183.704C367.648 172.689 365.79 164.979 362.059 159.457L362.087 159.472ZM338.872 167.039C340.216 163.663 342.46 161.975 345.591 161.975C347.664 161.975 349.35 162.762 350.666 164.307L337.071 190.671C336.928 188.582 336.842 186.279 336.842 183.704C336.842 175.965 337.514 170.415 338.872 167.039ZM352.324 200.269C350.951 203.66 348.707 205.362 345.605 205.362C343.918 205.362 342.503 204.875 341.345 203.931L354.282 178.826C354.354 180.343 354.397 181.973 354.397 183.704C354.397 191.357 353.71 196.879 352.324 200.269Z"
                  fill="url(#paint0_linear_2516_33271)"
                />
                <path
                  opacity="0.7"
                  d="M362.087 56.7764C358.371 51.2547 352.867 48.4939 345.605 48.4939C338.343 48.4939 332.596 51.126 329.008 56.4045C325.42 61.683 323.619 69.8798 323.619 81.009C323.619 92.1382 325.463 99.7485 329.151 105.213C332.84 110.677 338.329 113.41 345.591 113.41C352.853 113.41 358.642 110.763 362.245 105.47C365.847 100.178 367.648 92.0238 367.648 81.009C367.648 69.9942 365.79 62.2838 362.059 56.7621L362.087 56.7764ZM338.872 64.3438C340.216 60.9678 342.46 59.2798 345.591 59.2798C347.664 59.2798 349.35 60.0666 350.666 61.6115L337.071 87.9755C336.928 85.887 336.842 83.5839 336.842 81.009C336.842 73.27 337.514 67.7197 338.872 64.3438ZM352.324 97.5884C350.951 100.979 348.707 102.681 345.605 102.681C343.918 102.681 342.503 102.195 341.345 101.25L354.282 76.1453C354.354 77.6616 354.397 79.2924 354.397 81.0233C354.397 88.6764 353.71 94.1982 352.324 97.5884Z"
                  fill="white"
                />
              </g>
              <path
                opacity="0.1"
                d="M333.999 115.827C333.999 113.014 331.719 110.734 328.906 110.734H305.909H303.745C299.327 110.734 295.745 114.316 295.745 118.734V120.919V143.932C295.745 146.739 298.02 149.014 300.827 149.014C303.634 149.014 305.909 146.739 305.909 143.932V121.919C305.909 121.367 306.357 120.919 306.909 120.919H328.906C331.719 120.919 333.999 118.639 333.999 115.827Z"
                fill="white"
              />
              <path
                opacity="0.1"
                d="M390.092 197.698V169.596C390.092 166.785 387.814 164.507 385.003 164.507C382.193 164.507 379.914 166.785 379.914 169.596V197.698C379.914 200.508 382.193 202.787 385.003 202.787C387.814 202.787 390.092 200.508 390.092 197.698Z"
                fill="white"
              />
              <path
                d="M431.076 285.455L439.739 292.636C440.897 293.594 441.054 295.311 440.096 296.455C439.138 297.614 437.423 297.772 436.279 296.813L427.617 289.632C426.459 288.674 426.301 286.957 427.259 285.813C428.217 284.654 429.932 284.497 431.076 285.455Z"
                fill="#EAB308"
              />
              <path
                d="M421.87 291.849L423.485 302.993C423.7 304.481 422.671 305.854 421.184 306.069C419.697 306.283 418.325 305.253 418.11 303.765L416.495 292.622C416.281 291.134 417.31 289.761 418.797 289.546C420.283 289.332 421.656 290.362 421.87 291.849Z"
                fill="#EAB308"
              />
              <path
                d="M380.401 93.0107L384.518 87.1456C384.632 86.974 384.675 86.788 384.675 86.6021H382.573L378.428 92.51L373.939 95.9146C373.525 96.2293 373.439 96.8301 373.753 97.2592C373.939 97.5024 374.225 97.6312 374.511 97.6312C374.711 97.6312 374.911 97.5739 375.083 97.4309L379.085 94.3982L382.659 97.4738L381.387 102.137C381.244 102.652 381.544 103.167 382.059 103.31C382.145 103.339 382.23 103.339 382.316 103.339C382.731 103.339 383.117 103.067 383.231 102.638L384.661 97.388C384.761 97.0303 384.646 96.6584 384.36 96.4152L380.401 92.9964V93.0107Z"
                fill="#EFF6FF"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_2516_33271"
                  x1="345.634"
                  y1="151.189"
                  x2="345.634"
                  y2="216.105"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" stop-opacity="0.75" />
                  <stop offset="1" stop-color="white" stop-opacity="0.9" />
                </linearGradient>
              </defs>
            </svg>

            <h2
              class="text-4xl lg:text-6xl font-semibold text-surface-950 dark:text-surface-0 mt-8 text-center"
            >
              Page not found
            </h2>
            <p
              class="lg:text-xl text-surface-500 dark:text-white/64 mt-4 text-center"
            >
              Something gone wrong!
            </p>
            <a routerLink="/" class="button-primary mt-8">Go to Dashboard</a>
          </div>
        </div>
      </div>
    </section>
    <button
      class="layout-config-button config-link"
      (click)="layoutService.toggleConfigSidebar()"
    >
      <i class="pi pi-cog"></i>
    </button>
    <app-configurator simple />`,
})
export class Notfound {
  layoutService = inject(LayoutService);
}
